<template>
  <div class="orderlist-container">
    <div v-if="!isShowOrderDetail">
      <div class="orderlist-box">
        <el-tabs
          class="orderlist-el-tab"
          v-model="tabActiveName"
          @tab-click="handleClick"
        >
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane label="待支付" name="unpaid"></el-tab-pane>
          <el-tab-pane label="待发货" name="unsend"></el-tab-pane>
          <el-tab-pane label="待收货" name="waitReceive"></el-tab-pane>
          <el-tab-pane label="已完成" name="complete"></el-tab-pane>
        </el-tabs>
        <div style="margin-top: 42px">
          <el-empty :image-size="200" v-if="!orderList.length"></el-empty>
          <MyOrderItem
            v-else
            :status="status"
            v-for="item in orderList"
            :key="item.id"
            :order-item="item"
            @viewDetail="toViewDetail"
            @changeTab="changeTab"
          ></MyOrderItem>
        </div>
      </div>
      <div class="pagination-container">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 订单详情 -->
    <div v-if="isShowOrderDetail && orderDetailInfo" >
        <OrderDetail :detail-info="orderDetailInfo" @toBack="toBack" />
    </div>
  </div>
</template>

<script>
import MyOrderItem from "@/components/MyOrderItem";
import { getOrderList,getOrderDetail } from "@/api/home";
import OrderDetail from "./orderDetail.vue";
export default {
  components: { MyOrderItem, OrderDetail },
  data() {
    return {
      tabActiveName: "all",
      status: "",
      totalNum: 0, //总条数
      currentPage: 1,
      pageSize: 15,
      orderList: [],
      isShowOrderDetail:false,
      orderDetailInfo:null, //订单详情信息
    };
  },
  created() {
    console.log(this.$route)
    if(localStorage.getItem('status') == 1) {
      this.tabActiveName = "unpaid"
      this.status = 1
      this.getOrderList();
    }else {
    this.getOrderList();
    }
  },
  methods: {
    changeTab(status) {
      this.tabActiveName = 'complete'
      this.handleClick({name:'complete'})
    },
    toBack() {
        this.orderDetailInfo = null
        this.isShowOrderDetail = false
    },
    // 订单详情
    async toViewDetail(data) {
        const res = await getOrderDetail({
            order_no:data.order_no
        })
        console.log(res,'res详情')
        if(res.data) {
            this.orderDetailInfo = res.data
            this.isShowOrderDetail = true
        }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOrderList();
    },
    // 获取订单列表
    async getOrderList(status = "") {
      const { data } = await getOrderList({
        page: this.currentPage,
        status,
      });
      if (data.data) {
        this.orderList = data.data;
      }
      this.totalNum = data.total;
    },
    handleClick(tab) {
      this.currentPage = 1;
      switch (tab.name) {
        case "all":
          this.status = "";
          this.getOrderList(this.status);
          break;
        case "unpaid":
          this.status = 1;
          this.getOrderList(this.status);
          break;
        case "unsend":
          this.status = 2;
          this.getOrderList(this.status);
          break;
        case "waitReceive":
          this.status = 3;
          this.getOrderList(this.status);
          break;
        case "complete":
          this.status = 4;
          this.getOrderList(this.status);
          break;
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.orderlist-container {
  width: 100%;
}
.orderlist-box {
  margin: 0 40px;
}
.orderlist-el-tab /deep/ .el-tabs__item {
  font-size: 18px;
  font-weight: 400;
  color: @words;
}
.orderlist-el-tab /deep/ .el-tabs__item.is-active {
  font-size: 20px;
  font-weight: 600;
}
.orderlist-el-tab /deep/ .el-tabs__active-bar {
  display: none;
}
.pagination-container {
  margin-top: 98px;
  margin-bottom: 76px;
  display: flex;
  justify-content: center;
}
</style>